
export const SET_MSG = 'CONTRATOR_RESCISAO_MSG';
export const SET_EDITAR = 'CONTRATOR_RESCISAO_EDITAR';
export const SET_LISTA = 'CONTRATOR_RESCISAO_LISTA';
export const SET_ID = 'CONTRATOR_RESCISAO_ID'